<ag-grid-angular
    style="height: 300px; width: 100%"
    [rowData]="patientHistoryList"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    (columnResized)="onColumnResized()"
    (gridSizeChanged)="onGridSizeChanged($event)"
    [loading]="false"
    [modules]="agGridModuls"
    [theme]="agGridTheme"
>
</ag-grid-angular>
